import { Scenarios } from '@jfs/network'

const multiDeviceSession = {
  default: [
    {
      url: /agent\/session/,
      method: 'POST',
      response: {
        status: 'SUCCESS',
        sessionToken: '87679879879879',
        session: {
          accessToken: { tokenValue: '312908f5-f52f-4755-8085-a69517ba3fdcUSERACCESS', expiresIn: 60 },
          refreshToken: { tokenValue: '8ba27564-6864-4882-8231-3dca8a42b224USERREFRESH', expiresIn: 607753 },
          userIdentifierToken:
            'EMMEf2xpeHS0g5xq7dj3qKVPsK7Y0Zf0+nisJMqhoVJTcfRakgl1qW8V8Ab9zTXBc+pwmBaVa8y+ik6kQW2fln4/F1ijs7BW4mrtHSPOco736oiQ9xZr21oJOnOT+0XGDosPz+3GNum+po9gm1abeQ2VeirvthBAhBF8dOP33/Tr0MjOo+nS2yXlROMq0xdOBSeZ0k9e0xxSBpHf2hhIakfRvI4xXk8Blx+GoQRIEUjYFr8ISTD/kk67XVPw6hfUeu0NsMFPKPIkQSJtulrlRankigN+LrYIR7B3fLGp8bjATEMsbbnCUUwxQMqmI3zLCIVB3RGNsIRHFXTgqQY8mTskK+fOT3ly0YodhbNDYEJ/453u6Swe9aZWVkchCQZV7TmXtTN0bNo4qc6ejgKWgLl+HyDZ9S2QF3bUu5cmIHlRULgZ8kSuzuOw5b2eP6E6rZypv38W1Xavy3uQZHnOzFdVtBtuGHm8IlgQPAZ3xtWvmPxS1pczufsVTz6xhEktQSfeoOCrpg+wL8OoWZ52DCB2Ao7fpPUugxQFXQeF1GyqqBqzJVCnufoHdDnVEZg4IX1YwZrwv8fAPL7kywWDpHNXcx2/Q/shiPDa7X0ihvgQ7IjhXHSI8Nb7IdiTrz4oa0xfWmx58n23DVaL/yHvxx2zk8vb3fDPjjvG8/Gs9chNLV2+W5KWvJyoDnBgwYvgYxT9W02eVYdZY+JiCcBWULlvLHtXRyzE0RUazdD7bKUS1cFtk9juBRwsc8Ss83H19+0LvV+rWo5wjucvsg0PR/NQ7SRJhwp8ZDRXBw1GKXybaYeLu9+0DGoZ+XAt8/7j8OHTM6kui7ZbOnIQZPUBEBfDyOX0sxmxkZsA6ZAy774F8GmT5PNmcI/59L9MEmS3jtMXC++da9r4FWTaZAumpAnUZjLv3hrntBvSCUl5nxY=',
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /agent\/session/,
      method: 'POST',
      responseCode: 5000,
      response: { error: { code: 416, message: 'Invalid request' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { multiDeviceSession }
